import React, { Component } from 'react'
import { translate } from '../../../common/utils'
import { Grid, Row, Col } from 'react-bootstrap'

export default class AddressInput extends Component {
    constructor(p) {
        super(p)

    }

    render() {
        const { street, zip, city } = this.props.address
        return (
            <Row>
                <Col xs={4} md={4} lg={4}>
                    <span>Gatuadress:</span> <input onChange={this.props.onChange} value={street} type="text" name="street" className="form-control qlocxInput" />
                </Col>
                <Col xs={4} md={4} lg={4}>
                    <span>Postnummer:</span> <input onChange={this.props.onChange} value={zip} type="text" name="zip" className="form-control qlocxInput" />
                </Col>
                <Col xs={4} md={4} lg={4}>
                    <span>Stad:</span> <input onChange={this.props.onChange} value={city} type="text" name="city" className="form-control qlocxInput" />
                </Col>
            </Row>
        )
    }
}

